import { TableContainer, TableRow, TableCell, styled } from "@mui/material";

export const TableScrollWrapper = styled('div')(({ theme }) => ({
  position: 'relative',
  margin: '30px auto',
  width: '85%',
  [theme.breakpoints.down('md')]: {
    width: '95%',
    margin: '20px auto',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      width: '36px',
      borderRadius: theme.shape.borderRadius,
      background: `linear-gradient(to left, ${theme.palette.secondary.main}, transparent)`,
      pointerEvents: 'none',
    },
  },
}));

export const ScrollHintText = styled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('md')]: {
    display: 'block',
    color: theme.palette.text.primary,
    opacity: 0.7,
    fontSize: '0.8rem',
    fontStyle: 'italic',
    textAlign: 'center',
    marginTop: '20px',
    marginBottom: '-10px',
  },
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  borderRadius: theme.shape.borderRadius,
  boxShadow: `0px 0px 10px 2px rgba(255, 255, 255, 0.5)`,
  width: '100%',
  overflowX: 'auto',
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: theme.typography.fontWeightMedium,
  textAlign: 'center',
  padding: theme.spacing(1),
  border: `3px solid ${theme.palette.divider}`,
  whiteSpace: 'nowrap',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(0.5),
    fontSize: '0.85rem',
  },
}));

export const StyledHeaderCell = styled(StyledTableCell)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.dark,
  color: theme.palette.primary.main,
  textAlign: 'center',
  fontWeight: 700,
  fontSize: '1.2rem',
}));

export const ItemCell = styled(StyledTableCell)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    position: 'sticky',
    left: 0,
    zIndex: 2,
    backgroundColor: theme.palette.secondary.main,
    whiteSpace: 'normal',
    minWidth: '110px',
    maxWidth: '140px',
    fontSize: '0.75rem',
  },
}));

export const ItemHeaderCell = styled(StyledHeaderCell)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    position: 'sticky',
    left: 0,
    zIndex: 3,
    whiteSpace: 'normal',
    minWidth: '110px',
    maxWidth: '140px',
    fontSize: '0.9rem',
  },
}));

export const StyledRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.secondary.light,
  },
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.background.default,
  },
}));

export const CategoryCell = styled(StyledTableCell)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: '1.5rem',
  writingMode: 'vertical-rl',
  transform: 'rotate(180deg)',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
  },
}));

export const FormulaImage = styled('img')(({ theme }) => ({
  maxWidth: '50px',
  maxHeight: '50px',
  border: `2px solid ${theme.palette.divider}`,
  cursor: 'pointer',
}));